import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import dayjs from 'dayjs';

export default function ClientDetail() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClient();
  }, [id]);

  const fetchClient = async () => {
    try {
      const response = await api.get(`/clients/${id}`);
      setClient(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div></div>;
  }

  if (!client) {
    return <div className="text-center py-8">Klienti nuk u gjet</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/clients" className="text-gray-500 hover:text-gray-700">← Kthehu</Link>
        <h1 className="text-2xl font-bold text-gray-900">{client.name}</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="card">
          <h2 className="font-semibold text-gray-900 mb-4">Informacione</h2>
          <div className="space-y-2 text-sm">
            <p><span className="text-gray-500">Kodi:</span> {client.code}</p>
            <p><span className="text-gray-500">Tel:</span> {client.phone || '-'}</p>
            <p><span className="text-gray-500">Email:</span> {client.email || '-'}</p>
          </div>
          <div className="mt-4 pt-4 border-t">
            <p className="text-sm text-gray-500">Bilanci</p>
            <p className={`text-2xl font-bold ${client.balance > 0 ? 'text-red-600' : 'text-green-600'}`}>
              €{client.balance?.toFixed(2)}
            </p>
          </div>
        </div>

        <div className="card lg:col-span-2">
          <h2 className="font-semibold text-gray-900 mb-4">Biletat e Fundit</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-2">Data</th>
                  <th className="text-left py-2">Kodi</th>
                  <th className="text-left py-2">Pasagjer</th>
                  <th className="text-right py-2">Total</th>
                </tr>
              </thead>
              <tbody>
                {client.tickets?.map((ticket) => (
                  <tr key={ticket.id} className="border-b">
                    <td className="py-2">{dayjs(ticket.ticket_date).format('DD/MM/YY')}</td>
                    <td className="py-2">{ticket.ticket_code}</td>
                    <td className="py-2">{ticket.passenger_name}</td>
                    <td className="py-2 text-right font-medium">€{ticket.total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="card">
        <h2 className="font-semibold text-gray-900 mb-4">Pagesat e Fundit</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2">Data</th>
                <th className="text-left py-2">Shënim</th>
                <th className="text-right py-2">Shuma</th>
              </tr>
            </thead>
            <tbody>
              {client.payments?.map((payment) => (
                <tr key={payment.id} className="border-b">
                  <td className="py-2">{dayjs(payment.payment_date).format('DD/MM/YY')}</td>
                  <td className="py-2 text-gray-500">{payment.notes || '-'}</td>
                  <td className="py-2 text-right font-medium text-green-600">€{payment.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
